// GMO かんたんゲームボックス API ラッパー

declare global {
  interface Window {
    game_start?: (options: { callback: string | (() => void) }) => void;
    game_end?: (options: {
      callback: string | (() => void);
      score: number;
    }) => void;
    game_save?: (options: {
      callback: string | (() => void);
      data: string;
    }) => void;
    game_get_data?: (options: {
      callback: string | ((data: { gamedata: string }) => void);
    }) => void;
  }
}

/**
 * ゲーム開始時のAPI呼び出し
 * @param callback ゲーム開始後に実行するコールバック
 */
export function callGameStart(callback: () => void): void {
  if (typeof window.game_start === 'function') {
    window.game_start({ callback });
  } else {
    // 開発環境用フォールバック
    console.log('[DEV] game_start called');
    setTimeout(callback, 100);
  }
}

/**
 * ゲーム終了時のAPI呼び出し
 * @param score 最終スコア
 * @param callback スコア送信後に実行するコールバック
 */
export function callGameEnd(score: number, callback: () => void): void {
  if (typeof window.game_end === 'function') {
    window.game_end({ callback, score });
  } else {
    // 開発環境用フォールバック
    console.log('[DEV] game_end called with score:', score);
    setTimeout(callback, 100);
  }
}

/**
 * ゲームデータの保存
 * @param data 保存するデータ（JSON文字列）
 * @param callback 保存後に実行するコールバック
 */
export function callGameSave(data: string, callback: () => void): void {
  if (typeof window.game_save === 'function') {
    window.game_save({ callback, data });
  } else {
    // 開発環境用フォールバック
    console.log('[DEV] game_save called with data:', data);
    setTimeout(callback, 100);
  }
}

/**
 * 保存されたゲームデータの取得
 * @param callback データ取得後に実行するコールバック
 */
export function callGameGetData(
  callback: (data: { gamedata: string }) => void
): void {
  if (typeof window.game_get_data === 'function') {
    window.game_get_data({ callback });
  } else {
    // 開発環境用フォールバック
    console.log('[DEV] game_get_data called');
    setTimeout(() => callback({ gamedata: '{}' }), 100);
  }
}
